module.exports = __webpack_public_path__ + "img/logo_nescafe_2025.1bc91a09.png";